import React, { useState } from "react";
//lib
import { useSelector } from "react-redux";
import { getData } from "common-lib/lib";
// styled
import { Wf, BlockCol } from "../CommonRule/Rule";

const Rule = ({
  rule,
  createContent,
  gameId,
  windowDimensions,
  lang,
  sify,
  tify,
}) => {
  const imgsdomain = useSelector((state) => state.props.imgsdomain);
  const [isHorizontal, setIsHorizontal] = useState(true);
  const onLoad = (e) => {
    const ratio = e.target.naturalHeight / e.target.naturalWidth;
    if (ratio > 1.2) {
      setIsHorizontal(false);
    }
  };
  return (
    <>
      {getData(rule, ["title"]) !== "+" && <hr />}
      <BlockCol windowDimensions={windowDimensions}>
        {getData(rule, ["title"]) !== "+" && (
          <p className="title">
            {lang === "zh-tw"
              ? tify(getData(rule, ["title"]))
              : lang === "cn"
              ? sify(getData(rule, ["title"]))
              : getData(rule, ["title"])}
          </p>
        )}
        {getData(rule, ["icon", "link"]) && (
          <Wf img={getData(rule, ["icon", "link"])} isHorizontal={isHorizontal}>
            <img
              className="object-fit-scale mb20 h100"
              alt=""
              onLoad={(e) => onLoad(e)}
              src={`${imgsdomain}/vp_project/common/${gameId}/symbolList/${getData(
                rule,
                ["icon", "link"]
              )}.png`}
            />
          </Wf>
        )}

        <div className="rules">
          <div
            dangerouslySetInnerHTML={createContent(
              getData(rule, ["content"]),
              gameId,
              imgsdomain
            )}
          />
        </div>
      </BlockCol>
    </>
  );
};

const Rules = (props) => {
  const { helpData } = props;
  const newHelpData = getData(helpData, ["data"]).filter((rule) => rule?.["icon"]?.["link"] !== "random_wild");
  return (
    <>
      {newHelpData.map((rule, k) => (
        <Rule rule={rule} key={k} {...props} />
      ))}
    </>
  );
};

export default Rules;
